import { createApi } from "@reduxjs/toolkit/query/react";
import baseQuery from "../baseQuery";
import { FIELD_MASTER_API } from "../../Api";

const BASE_URL = process.env.REACT_APP_SERVER_URL;

const FieldMasterApi = createApi({
  reducerPath: "fieldMasterApi",
  baseQuery,
  tagTypes: ["FieldMasterApi"],
  endpoints: (builder) => ({
    getFieldMaster: builder.query({
      query: ({ params, searchParams }) => {
        if (searchParams) {
          return {
            url: FIELD_MASTER_API + "/search/" + searchParams,
            method: "GET",
            headers: {
              "Content-type": "application/json; charset=UTF-8",
            },
            params
          };
        }
        return {
          url: FIELD_MASTER_API,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
          params
        };
      },
      providesTags: ["FieldMasterApi"],
    }),
    getFieldMasterById: builder.query({
      query: (id) => {
        return {
          url: `${FIELD_MASTER_API}/${id}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      providesTags: ["FieldMasterApi"],
    }),
    addFieldMaster: builder.mutation({
      query: (payload) => ({
        url: FIELD_MASTER_API,
        method: "POST",
        body: payload,
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["FieldMasterApi"],
    }),
    updateFieldMaster: builder.mutation({
      query: (payload) => {
        const { id, ...body } = payload;
        return {
          url: `${FIELD_MASTER_API}/${id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: ["FieldMasterApi"],
    }),
    deleteFieldMaster: builder.mutation({
      query: (id) => ({
        url: `${FIELD_MASTER_API}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["FieldMasterApi"],
    }),
  }),
});

export const {
  useAddFieldMasterMutation, useDeleteFieldMasterMutation, useGetFieldMasterByIdQuery, useGetFieldMasterQuery,
  useUpdateFieldMasterMutation
} = FieldMasterApi;

export default FieldMasterApi;
